import React from "react";

const AboutUs = () => {
  const company_about_us = localStorage.getItem("company_about_us");

  return (
    <>
      <div
        style={{ padding: "15px" }}
        dangerouslySetInnerHTML={{
          __html: company_about_us,
        }}
      />
    </>
  );
};

export default AboutUs;